module.exports = __webpack_public_path__ + "static/media/compareItems.acbaaecf.svg";